import { Table } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import ReportByTaskSummaryTableBody from './ReportByTaskSummaryTableBody';
import type { TaskPayReportRowType } from '@econtractor/types';

interface ReportByTaskSummaryTableProps {
    users: TaskPayReportRowType[];
}

const ReportByTaskSummaryTable = ({ users }: ReportByTaskSummaryTableProps) => {
    const { t } = useTranslation(['Reports']);

    return (
        <div className="crm-table-wrap">
            <Table className="ObjectRepTable TaskPaySummaryTable table-hover">
                <thead>
                    <tr className="bg-light">
                        <td className="head-name">{t('usersFields.user')}</td>
                        <td className="text-end head-count">{t('tasksFields.count')}</td>
                        <td className="text-end head-income">{t('tasksFields.income')}</td>
                    </tr>
                </thead>
                <ReportByTaskSummaryTableBody users={users} />
            </Table>
        </div>
    );
};

export default ReportByTaskSummaryTable;
